<template>
    <header class="login-header">
        <h4 v-if="top_text" v-html="top_text"></h4>
        <h1 class="logo">
            <svg><use xlink:href="#logo--sprite"></use></svg>
        </h1>
        <h2 v-if="title" v-html="title"></h2>
        <h3 v-if="sub_title" v-html="sub_title"></h3>
        <p v-if="text" v-html="text"></p>
    </header>

</template>

<script>
import "@/assets/svg/logo.svg?sprite";

export default {
    name: 'login-header',
    props: {
        top_text: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        sub_title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
    }

}
</script>

<style lang="scss">
    .login-header {
        margin-bottom: 40px;
        max-width: 460px;
        margin-left: auto;
        margin-right: auto;

        .logo {

            svg {
                display: block;
                height: 64px;
                width: 320px;
                margin: 0 auto;
                fill: var(--dark-blue);
            }
        }

        .link {
            color: var(--blue);
        }


        h2 {
            display: block;
            color: var(--black-90);
            margin: 32px 0 0;
            font: var(--font-fg-16);
            text-align: center;
        }
        
        h3 {
            margin: 5px 0 0;
            font-size: 12px;
            color: var(--black-90);
            text-align: center;
        }

        h4 {
            text-align: center;
            font-size: 16px;
            padding-bottom: 42px;
        }

        p {
            font-size: 12px;
            color: var(--black-60);
            text-align: center;
            margin: 16px 0 0;
        }
    }
</style>
